import { findByIdFromIdsCollectionFn } from '@Utils';

function createFnSetSelectedAs(val) {
  return function mapSetSelectedAs(item) {
    return item.set('selected', val);
  };
}

export function setWholeThesaurusAs(state, pathToItems, pathToFilter, selected) {
  return state.updateIn(pathToItems, (items) => items.map(createFnSetSelectedAs(selected))).setIn([...pathToFilter, 'selected'], selected);
}

export function syncAcordingToGroups(selectedGroupIds) {
  return function sync(items) {
    return items.map((item) => {
      const idForSearch = item.getIn(['rootIds', 1]) || item.get('id');

      const selected = Boolean(selectedGroupIds.find(findByIdFromIdsCollectionFn(idForSearch)));

      return item.set('selected', selected);
    });
  };
}

export default function syncThesaurusItemsWithGrouopsHandler(state, action) {
  const { key, filterId } = action.payload;
  const pathToFilter = [key, 'items', filterId];
  const pathToItems = [...pathToFilter, 'thesaurusGroups', 'items'];
  const filter = state.getIn(pathToFilter);
  const groups = filter.get('groups');
  const selectedGroup = groups.filter((item) => item.get('selected'));

  if (groups.count() === selectedGroup.count()) {
    return setWholeThesaurusAs(state, pathToItems, pathToFilter, true);
  }

  if (selectedGroup.count() === 0) {
    return setWholeThesaurusAs(state, pathToItems, pathToFilter, false);
  }

  const selectedGroupIds = selectedGroup.map((item) => item.get('id'));

  return state.updateIn(pathToItems, syncAcordingToGroups(selectedGroupIds));
}
